import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Core from '../../../class/Core';
import moment from 'moment';
import InputMask from 'react-input-mask';
import 'moment/locale/pt-br';

//actions
import * as UserActions from '../../../actions/UserActions';
import * as ManagerStatusActions from '../../../actions/StatusManagerActions.js';
import * as RedirectActions from '../../../actions/RedirectActions';
import * as StatusActions from '../../../actions/StatusActions';
import Alert from 'react-s-alert';

class EmpresaTipoCobranca extends React.Component{
    constructor(props){
        super(props);

        this.core = new Core();
        this.width = window.innerWidth * 0.66 ;
        this.height = this.width * window.innerHeight / window.innerWidth ;

        //define locale moment
        moment.locale('pt-BR');
        this.state = {
            relatorio_empresa: [],
            qtd_total: 0,
            tipo_cobranca: null,
            exibicao: null
        }

        this.getTableShowEmpresa = this.getTableShowEmpresa.bind(this);
        this.getTableHeaderEmpresa = this.getTableHeaderEmpresa.bind(this);
        this.getTableShowPlanos = this.getTableShowPlanos.bind(this);
        this.getTableHeaderPlanos = this.getTableHeaderPlanos.bind(this);
        this.handlerSubmit = this.handlerSubmit.bind(this);
    }

    componentWillMount(){
        this.props.action.showManager();
        this.props.action.redirectClear();
    }

    handlerSubmit(event){
        event.preventDefault();
        let self = this;
        let curl = null;

        let data = {
            plano: event.target.plano.value
        }

        switch(event.target.tipo_cobranca.value){
            case "1":
                data.tipo_cobranca = 'LISTA'
                this.state.tipo_cobranca = 1;
                break;
            case "2":
                data.tipo_cobranca = 'MASSA_TOTAL'
                this.state.tipo_cobranca = 2;
                break;
            case "3":
                data.tipo_cobranca = 'CAGED'
                this.state.tipo_cobranca = 3;
                break;
            default:
                data.tipo_cobranca = 'LISTA'
                this.state.tipo_cobranca = 1;
                break;
        }

        if(data.plano ===  ""){
            this.state.exibicao = 'PLANOS';
        } else {
            this.state.exibicao = 'EMPRESA';
        }

        this.props.action.loadingStatus();
        curl = self.core.getUrl() + self.core.getVersionAPI() + "empresa/relatorios/lista-empresa-tipo-cobranca";
        fetch(curl, {
                headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Authorization': self.core.formatAutorizationToken(self.core.getToken())                
            },
            method: 'POST',
            body: JSON.stringify(data)
        })
        .then(res => self.core.responseConvert(res))
        .then((response) => {
            self.setState({
                relatorio_empresa: response.content,
                qtd_total: response.content.length
            });
            self.props.action.loadedStatus();
        })
        .catch((err) => {
            self.core.catchFecth(err)
            self.props.action.loadedStatus();
        });
    }

    getTableShowEmpresa(){
        return this.state.relatorio_empresa.map((data, index) => {
            return <tr key={index} >
                <td>{String(data.id_plno).padStart(5,"0")}</td>
                <td>{String(data.id_empr_plno).padStart(5,"0")}</td>
                <td>{String(data.id_tr_plno).padStart(3,"0")}</td>
                <td>{String(data.emrn_cd_recnum).padStart(7,"0")}</td>
                <td>{String(data.id_empr).padStart(7,"0")}</td>
                <td>{data.cnpj_empr}</td>
                <td>{data.razao_empr}</td>
                <td>{data.dt_ult_pagto}</td>
            </tr>
        });
    }
    getTableHeaderEmpresa(){
        return <tr>
            <td>Id Plno</td>
            <td>Id Empr/Plno</td>
            <td>Plano</td>
            <td>Recnum</td>
            <td>Id Empresa</td>
            <td>CNPJ</td>
            <td>Razao Social</td>
            <td>Pagamento</td>
        </tr>
    }
    getTableShowPlanos(){
        return this.state.relatorio_empresa.map((data, index) => {
            return <tr key={index} >
                <td>{String(data.id_tr_plno).padStart(5,"0")}</td>
                <td>{String(data.qtd_empr).padStart(5,"0")}</td>
            </tr>
        });
    }
    getTableHeaderPlanos(){
        return <tr>
            <td>Plano</td>
            <td>Qtd Empresas</td>
        </tr>
    }

    render(){
        console.log("render=>");
        let tableContentEmpresa = null;
        let tableHeaderEmpresa  = null;
        let tableTotaisEmpresa  = null;
        let tableQtdTotalEmpresa  = null;
        if(this.props.redirect.url){
            return <Redirect to={this.props.redirect.url} />;
        }

        if (this.state.exibicao === 'PLANOS') {
            if(this.state.relatorio_empresa.length){
                tableContentEmpresa  = this.getTableShowPlanos();
                tableHeaderEmpresa   = this.getTableHeaderPlanos();   
                tableTotaisEmpresa   = <td>Quantidade de Empresas</td>
                tableQtdTotalEmpresa =  <td style={{textAlign:"right"}}>{this.state.qtd_total.toLocaleString('de-DE')}</td>


            } else {
                tableContentEmpresa = <tr>
                    <td colSpan={8}>  </td>
                </tr>           
            }    
        } else {
            if(this.state.relatorio_empresa.length){
                tableContentEmpresa = this.getTableShowEmpresa();
                tableHeaderEmpresa  = this.getTableHeaderEmpresa();    
                tableTotaisEmpresa  = <td>Quantidade de Planos</td>
                tableQtdTotalEmpresa =  <td style={{textAlign:"right"}}>{this.state.qtd_total.toLocaleString('de-DE')}</td>
            } else {
                tableContentEmpresa = <tr>
                    <td colSpan={8}>  </td>
                </tr>           
            }    
        }

        return <div className="page">
            <div className="page-content">
                <h2>Empregadores - Tipo Cobrança</h2>
                <p>Consulta o Tipo de Cobrança utilizado pelos Empregadores Cadastradas Por Plano no Sistema BSFOnline</p>

                <div className="panel">
                    <div className='panel-title'>
                        <h3>
                            Informe o Plano para a pesquisa e/ou Empregador (Nome ou CNPJ/CPF) para a pesquisa
                        </h3>
                        <div  className="seleciona-mes-doc" >
                            <form onSubmit={this.handlerSubmit}>
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <InputMask name="plano" id="plano" placeholder="Plano" className="form-control" mask="999" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label> <b>Tipo Cobrança</b> </label> <br/>
                                                <input type="radio" name="tipo_cobranca" value="1" /> Lista <br/>
                                                <input type="radio" name="tipo_cobranca" value="2" /> Massa Total <br/>
                                                <input type="radio" name="tipo_cobranca" value="3" /> CAGED <br/>
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <button type="Submit" className="btn btn-primary">pesquisar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="panel">
                    <div className="panel-body container-fluid">

                        <table className="table table-striped table-doc">
                            <tr>
                                <thead>
                                    {tableTotaisEmpresa}
                                </thead>
                                <tbody>
                                    {tableQtdTotalEmpresa}
                                 </tbody>
                            </tr>
                        </table>

                        <table className="table table-striped table-doc">
                            <thead>
                                {tableHeaderEmpresa}
                            </thead>
                            <tbody>
                                {tableContentEmpresa}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }
}

function mapStateProps(state, props) {
    return {
        user: state.user,
        managerStatus: state.managerStatus,
        redirect: state.redirectReducer
    }
}

function mapDispatchProps(dispatch) {
    return {
        action: bindActionCreators({
            ...UserActions,
            ...ManagerStatusActions,
            ...RedirectActions,
            ...StatusActions
        }, dispatch)
    }
}
export default withRouter(connect(mapStateProps, mapDispatchProps)(EmpresaTipoCobranca))
